"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserAssignmentResourceSerializer = void 0;
const dp_http_client_lib_1 = require("@greatmindsorg/dp-http-client-lib");
const user_assignment_serializer_1 = require("./user-assignment.serializer");
const assignment_resource_serializer_1 = require("./assignment-resource.serializer");
const date_helper_1 = require("../../helpers/date.helper");
class UserAssignmentResourceSerializer extends dp_http_client_lib_1.PageableSerializer {
    constructor(userAssignmentSerializer = new user_assignment_serializer_1.UserAssignmentSerializer(), assignmentResourceSerializer = new assignment_resource_serializer_1.AssignmentResourceSerializer()) {
        super();
        this.userAssignmentSerializer = userAssignmentSerializer;
        this.assignmentResourceSerializer = assignmentResourceSerializer;
    }
    serializeOne(data) {
        return {
            id: data.id,
            userAssignment: data.userAssignment
                ? this.userAssignmentSerializer.serializeOne(data.userAssignment)
                : null,
            assignmentResource: data.assignmentResource
                ? this.assignmentResourceSerializer.serializeOne(data.assignmentResource)
                : null,
            status: data.status,
            completedAt: (0, date_helper_1.toLocalDate)(data.completedAt),
            startedAt: (0, date_helper_1.toLocalDate)(data.startedAt),
            createdAt: (0, date_helper_1.toLocalDate)(data.createdAt),
            maxScore: data.maxScore,
            isScorable: data.isScorable,
        };
    }
}
exports.UserAssignmentResourceSerializer = UserAssignmentResourceSerializer;
//# sourceMappingURL=user-assignment-resource.serializer.js.map